import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { distinctUntilChanged } from 'rxjs/operators';
import { NotificationService } from '../../services/notification.service';
import { Router, NavigationStart } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-feedback-modal',
  templateUrl: './feedback-modal.component.html',
  styleUrls: ['./feedback-modal.component.css'],
})
export class FeedbackModalComponent implements OnChanges {
  @Input() openModal: boolean;
  @Input() isFeedbackFeature: string;
  @Output() modalClosed = new EventEmitter<void>();

  feedbackForm = { type: null, rating: 0, subject: null, followup: false, description: null };
  feedbackTypes = [
    { label: 'General Feedback', value: 'General Feedback' },
    { label: 'Issue or Bug', value: 'Issue or Bug' },
    { label: 'Needed Content', value: 'Needed Content' },
    { label: 'Desired Feature', value: 'Desired Feature' },
  ];
  noInput = true;
  selectedFeedbackType = {};
  descriptionFC = new FormControl('');
  subjectFC = new FormControl('');
  feedbackFollowupFC = new FormControl('');
  @ViewChild('feedbackModal') feedbackModal: any;

  constructor(
    private readonly modalService: NgbModal,
    private notificationService: NotificationService,
    private router: Router,
  ) {
    this.feedbackFollowupFC.valueChanges.pipe(distinctUntilChanged()).subscribe((res) => {
      if (this.feedbackFollowupFC.value[0]) {
        this.feedbackForm.followup = true;
      } else {
        this.feedbackForm.followup = false;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['openModal'] && changes['openModal'].currentValue) {
      this.openFeedbackModal();
      if (this.isFeedbackFeature === 'true') {
        this.selectFeedbackType(this.feedbackTypes[0]);
        this.subjectFC.setValue('Preview features feedback');
        this.descriptionFC.setValue('');
      }
    }
  }

  selectFeedbackType(feedback: object) {
    this.selectedFeedbackType = feedback;
    this.feedbackForm.type = feedback['value'];
    this.checkFeedbackInput();
  }

  checkFeedbackInput() {
    this.feedbackForm.description = this.descriptionFC.value;
    let empty = true;
    for (const key of Object.keys(this.feedbackForm)) {
      const detail = this.feedbackForm[key];
      if (detail != null && detail != '' && key != 'rating') {
        empty = false;
      } else {
        if (detail > 0) {
          empty = false;
        }
      }
    }
    this.noInput = empty;
  }

  openFeedbackModal() {
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationStart) {
        this.modalService.dismissAll();
      }
    });
    this.modalService.open(this.feedbackModal, { ariaLabelledBy: 'modal-title', windowClass: 'feedback-modal-width' }).result.then(
      (result) => {
        if (result == 'Send') {
          this.notificationService
            .sendFeedback(
              this.feedbackForm.type,
              this.feedbackForm.rating,
              this.feedbackForm.subject,
              this.feedbackForm.followup,
              this.feedbackForm.description,
            )
            .subscribe((data) => {
              this.resetFeedbackForm();
            });
          this.notificationService.showSuccess('Feedback sent successfully');
          this.resetFeedbackForm();
          this.modalClosed.emit();
        } else {
          this.resetFeedbackForm();
          this.modalClosed.emit();
        }
      },
      (reason) => {
        this.modalClosed.emit();
      },
    );
  }

  setFeedbackSubject() {
    this.feedbackForm.subject = this.subjectFC.value;
    this.checkFeedbackInput();
  }

  setFeedbackDescription() {
    this.feedbackForm.description = this.descriptionFC.value;
    this.checkFeedbackInput();
  }

  resetFeedbackForm() {
    this.feedbackForm = { type: null, rating: 0, subject: null, followup: false, description: null };
    this.subjectFC.reset();
    this.descriptionFC.reset();
  }
}
